import {
  QuestionnaireSectionProps,
  QuestionProps,
} from '@/types/questionnaire';
import AdminQuestionnaireLayout from '../components/AdminQuestionnaireLayout';
import { AdminSidebarItems } from '../components/AdminSidebarItems';
import { useState } from 'react';
import useQuestion from './hooks/useQuestion';
import { QuestionDetails } from './components/QuestionDetails';
import { QuestionsBreadcrumb } from './components/QuestionBreadcrumb';

interface IndexProps {
  section: QuestionnaireSectionProps & { current_question_id: number } & {
    questionnaire_template_title: string;
  } & { questions: Pick<QuestionProps, 'id' | 'key' | 'order'>[] };
}

export default function Index({ section }: IndexProps) {
  const [currentQuestionId, setCurrentQuestionId] = useState<number>(
    section.current_question_id
  );
  const { questionDetails, isLoading } = useQuestion({
    questionId: currentQuestionId,
  });
  return (
    <AdminQuestionnaireLayout
      heading="Question Keys"
      breadCrumbComponent={
        <QuestionsBreadcrumb
          templateId={section.questionnaire_template_id}
          templateTitle={section.questionnaire_template_title}
          section={section}
        />
      }
      leftComponent={
        <AdminSidebarItems
          data={section.questions}
          selectedId={currentQuestionId}
          onSelect={setCurrentQuestionId}
          displayField="key"
          testId="question-item"
        />
      }
      rightComponent={
        <QuestionDetails
          templateId={section.questionnaire_template_id}
          sectionQuestions={section.questions}
          questionDetails={questionDetails}
          isLoading={isLoading}
        />
      }
    />
  );
}
